export default "//kitchen-prod-asset.oss-cn-shanghai.aliyuncs.com/kitchen/online/static/media/LIL.png";